import { useConfirmContext } from "../Providers/confirm.provider";

export function useConfirm() {
    const { confirmDispatch } = useConfirmContext();

    const Types = {
        TYPE_DEFAULT: "default",
        TYPE_INFOR: "info",
        TYPE_SUCCESS: "success",
        TYPE_WARNING: "warning",
        TYPE_DANGER: "danger",
        TYPE_ERROR: "error",
        TYPE_INPUT: "input",
        TYPE_CUSTOM: "custom",
        TYPE_CONTROLLED: "controlled",
    };

    const Confirm = (data) => {
        confirmDispatch({
            type: "ADD",
            payload: {
                content: {
                    alertType: data.alertType ? data.alertType : Types.TYPE_DEFAULT,
                    title: data.title,
                    textBody: data.textBody,
                    onConfirm: data.onConfirm,
                    onCancel: data.onCancel,
                    confirmBtnBsStyle: data.confirmBtnBsStyle,
                    cancelBtnBsStyle: data.cancelBtnBsStyle,
                    confirmBtnText: data.confirmBtnText,
                    cancelBtnText: data.cancelBtnText,
                    showCancel: data.showCancel,
                    style: data.style,
                    closeOnClickOutside: data.closeOnClickOutside,
                },
            },
        });
    };

    return {
        Confirm,
        Types,
    };
}
